import {
  Card,
  Tag,
} from "antd";

const ProductGroupCard = ({ product }) => {
  const statusColors = {
    Available: "green",
    Disabled: "orange",
  };

  const handleCardClick = () => {
    // Handle card click event here
  };

  return (
    <Card
      hoverable
      cover={
        <img
          alt={product.title}
          src={product.Image}
          style={{
            height: 200, // Set a fixed height for the image
            width: "100%", // Ensure the image takes the full width of the card
            objectFit: "cover", // Maintain aspect ratio and crop if necessary
          }}
        />
      }
      onClick={handleCardClick}
      //   actions={[
      //     <Dropdown
      //       overlay={
      //         <Space direction="vertical">
      //           <Button type="text" block>
      //             Edit
      //           </Button>
      //           <Button type="text" block danger>
      //             Delete
      //           </Button>
      //         </Space>
      //       }
      //       trigger={["click"]}
      //     >
      //       <MoreOutlined style={{ fontSize: 18 }} />
      //     </Dropdown>,
      //   ]}
      style={{
        border:
          product.Status === "Available" ? "1px solid #52c41a" : undefined,
      }}
    >
      <Tag color={statusColors[product.Status]}>{product.Status}</Tag>
      <h4 style={{ margin: "10px 0 4px" }}>{product.GroupName}</h4>
      {/* <p style={{ marginBottom: 0, color: "#888" }}>
        {product.date} | {product.category}
      </p> */}
      {/* <p style={{ fontWeight: 500 }}>{product.price}</p> */}
    </Card>
  );
};

export default ProductGroupCard;
